import { useTranslation } from 'react-i18next'
import TeamCreditHistory from '../../components/teams/TeamCreditHistory'
import CreditHistory from './CreditHistoryPanel'
import { useActiveWallet } from './useActiveWallet'

export default function ActiveWalletHistory() {
  const { t } = useTranslation('settings')
  const wallet = useActiveWallet()
  if (wallet.kind === 'personal') return <CreditHistory />
  if (!wallet.canViewFinancials) {
    return <div>
      <p className="mb-1 text-base text-muted-foreground" data-testid="billing-wallet-label">
        {t('settingsModal.billing.teamCredits', { name: wallet.team.name })}
      </p>
      <p className="text-base text-muted-foreground" data-testid="billing-team-history-access">{t('settingsModal.billing.teamHistoryAccess')}</p>
    </div>
  }
  // Remount resets pagination and removes the preceding wallet's statement.
  return <TeamCreditHistory key={wallet.team.id} teamId={wallet.team.id} showBalanceHeader={false} presentation="table" />
}
